import store from '@/store'

export default {
	data() {
		return {
			$_resizeTimer: null
		}
	},
	watch: {
		$route(route) {
			if (this.device === 'mobile' && this.sidebar.opened) {
				store.dispatch('app/closeSideBar', { withoutAnimation: false })
			}
		}
	},
	beforeMount() {
		window.addEventListener('resize', this.$_resizeHandler)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.$_resizeHandler)
		if (this.$_resizeTimer) {
			clearTimeout(this.$_resizeTimer)
		}
	},
	mounted() {
		const isMobile = this.$_isMobile()
		if (isMobile) {
			store.dispatch('app/toggleDevice', 'mobile')
			store.dispatch('app/closeSideBar', { withoutAnimation: true })
		}
	},
	methods: {
		// use $_ for mixins properties
		// https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
		$_isMobile() {
			// 使用 User Agent 判断是否为移动设备，而不是窗口宽度
			// 避免打开 DevTools 导致菜单自动收起
			const ua = navigator.userAgent.toLowerCase()
			const mobileKeywords = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
			return mobileKeywords.test(ua)
		},
		$_resizeHandler() {
			// 防抖处理：避免频繁触发（DevTools 打开时窗口尺寸变化导致多次触发）
			if (this.$_resizeTimer) {
				clearTimeout(this.$_resizeTimer)
			}

			this.$_resizeTimer = setTimeout(() => {
				if (!document.hidden) {
					const isMobile = this.$_isMobile()
					store.dispatch('app/toggleDevice', isMobile ? 'mobile' : 'desktop')

					if (isMobile) {
						store.dispatch('app/closeSideBar', { withoutAnimation: true })
					}
				}
			}, 250)
		}
	}
}
